module.exports = __webpack_public_path__ + "media/bandits.8706865d.mp3";